import React from "react";

import { OrdersPolaris2 } from "../../components/order/OrdersPolaris2";
import { ORDER_FILTER_SELLER } from "../../constants";
import { getPathFromRouter } from "../../helper";
import { USER_ROLE } from "../../variable";

export const AdminOrdersPagePolaris2 = (...props) => {
    const path = React.useMemo(() => {
        return getPathFromRouter(props);
    }, [props]);

    return (
        <OrdersPolaris2
            role={USER_ROLE.Admin}
            ordersFilter={ORDER_FILTER_SELLER}
            path={path}
        />
    );
};
